import '@refinitiv-ui/elements/button';
import { LitElement, html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import '../components/heimdall-error.js';
import '../components/heimdall-loader.js';
import '../components/login-frame.js';

import '../theme.js';

import { finalizeRedirection } from '@lseg-ciam/auth/login';
import { knownLinkOrigins } from '../workspace-config.js';

@customElement('heimdall-redirect-link')
export class HeimdallRedirectLink extends LitElement {
  @state()
  _error: unknown = null;

  async firstUpdated() {
    try {
      await finalizeRedirection({ knownLinkOrigins });
    } catch (error) {
      this._error = error;
    }
  }

  render() {
    return html`<login-frame> ${this.getFrameContent()} </login-frame>`;
  }

  getFrameContent() {
    if (this._error) {
      return html`<heimdall-error .error=${this._error}></heimdall-error>`;
    }
    return html`<heimdall-loader message=""></heimdall-loader>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'heimdall-redirect-link': HeimdallRedirectLink;
  }
}
